import {
  UPDATE_FILTER_OPTIONS,
} from '../constants';

const filterOptions = (state = {}, action) => {
  switch(action.type) {
    case UPDATE_FILTER_OPTIONS:
      return {...state, ...action.filterOptions}
    default:
      return state;
  }
}

export default filterOptions;


// WEBPACK FOOTER //
// ./src/reports/general/javascripts/reducers/filterOptionsReducer.js